import { render, staticRenderFns } from "./AssetHistoryTab.vue?vue&type=template&id=ffa2a5e8&scoped=true"
import script from "./AssetHistoryTab.vue?vue&type=script&lang=js"
export * from "./AssetHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./AssetHistoryTab.vue?vue&type=style&index=0&id=ffa2a5e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa2a5e8",
  null
  
)

export default component.exports